import { useEffect, useState } from 'react'
import useFetch from '../../../hooks/useFetch';
import './bigScreen.scss'
import { IBigScreenPayload } from '../../../interfaces/bigScreenPayload';
import { IBigScreenLot } from '../../../interfaces/bigScreenLot';
import BidNotificationDialog from './BidNotificationDialog';
import BigScreenCountdownTimer from './BigScreenCountdownTimer';
import AdHocDialog from './AdHocDialog';
import useCommonFunctions from "../../../hooks/useCommonFunctions"
import { useParams } from "react-router-dom"
import BigScreenCarouselHorizontal from './BigScreenCarouselHorizontal';
import BigScreenCarouselVertical from './BigScreenCarouselVertical';
import { BigScreenDisplayMode } from '../../../common/enums/BigScreenDisplayMode';
import BigScreenModeSwitcher from './BigScreenModeSwitcher';


const BigScreen = ({ match }) => {
    const [bigScreenPayload, setBigScreenPayload] = useState<IBigScreenPayload>({} as IBigScreenPayload)
    const [isBigScreenFound, setIsBigScreenFound] = useState<any>(true)
    const [isBidNotificationDialogOpen, setIsBidNotificationDialogOpen] = useState<boolean>(false)
    const [newBidQueue, setNewBidQueue] = useState<IBigScreenLot[]>([])
    const [currentLatestBid, setCurrentLatestBid] = useState<IBigScreenLot>({} as IBigScreenLot)
    let { campaignSlug } = useParams()

    const bigScreenApi = useFetch("big-screens");
    const commonFunctions = useCommonFunctions()

    const getBigScreenPayload = (): void => {
        bigScreenApi.get(`/${campaignSlug}/payload`).then((data: IBigScreenPayload) => {
            if (data) {

                //remove child lots
                for (let i = 0; i < data.lotList.length; i++) {
                    if (data.lotList[i].parentLotId) {
                        data.lotList.splice(i, 1)
                        i--
                    }
                }
                checkForNewBid(data.latestBid)
                setBigScreenPayload(data)
            } else {
                setIsBigScreenFound(false)
            }
        }).catch((err: Error) => {
            console.log(err)
        })
    }

    const checkForNewBid = (newBid: IBigScreenLot) => {
        if (newBid && newBid.winningBidId !== currentLatestBid.winningBidId) {
            if (currentLatestBid.winningBidId) {
                let tempNewBidQueue = [...newBidQueue]
                tempNewBidQueue.push(newBid)
                setNewBidQueue(tempNewBidQueue)
            }
            setCurrentLatestBid(newBid)
        }
    }

    const determineBidType = (bidType: string): string => {
        if (bidType === "CUMULATIVE") {
            return "pledge"
        } else if (bidType === "BUYITNOW") {
            return "purchase"
        } else {
            return "bid"
        }
    }

    useEffect(() => {
        if (newBidQueue.length > 0) {
            setIsBidNotificationDialogOpen(true)
            newBidQueue.splice(0, 1)
            let timer = setTimeout(() => {
                setIsBidNotificationDialogOpen(false)
            }, (bigScreenPayload.bidPopupTime * 1000));

            return () => {
                clearTimeout(timer);
            }
        }
    }, [newBidQueue])

    useEffect(() => {
        if (campaignSlug) {
            getBigScreenPayload()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaignSlug])

    useEffect(() => {
        let timer = setTimeout(() => {
            getBigScreenPayload()
        }, 10000);

        return () => {
            clearTimeout(timer);
        }
    }, [bigScreenPayload])



    return (
        <>
            {
                bigScreenPayload.campaignId &&
                <div className='big-screen' style={{
                    backgroundColor: bigScreenPayload.bodyBackgroundColor,
                    backgroundImage: bigScreenPayload.bodyBackgroundUrl ? `url(${bigScreenPayload.bodyBackgroundUrl})` : 'none',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                    <div className='top-section-wrapper'>
                        {(bigScreenPayload.title || bigScreenPayload.headerLeftImageUrl || bigScreenPayload.headerRightImageUrl) &&
                            <section className='header' style={{ backgroundColor: bigScreenPayload.headerBackgroundColor, color: bigScreenPayload.headerFontColor }}>
                                <div className='logo-wrapper' style={{ width: `${180 * bigScreenPayload.headerLeftImageSize}px` }}>
                                    {bigScreenPayload.headerLeftImageUrl && <img alt="logo" src={bigScreenPayload.headerLeftImageUrl} />}
                                </div>

                                {bigScreenPayload.isCountdownTimer ?
                                    <BigScreenCountdownTimer
                                        countdownStartDate={bigScreenPayload.countdownStartDate}
                                        countdownEndDate={bigScreenPayload.countdownEndDate}
                                        campaignNotYetOpenTitle={bigScreenPayload.campaignNotYetOpenTitle}
                                        countdownClosedMessage={bigScreenPayload.countdownClosedMessage}
                                        campaignLiveTitle={bigScreenPayload.campaignLiveTitle}
                                    />
                                    :
                                    <div className='title-wrapper' style={{ fontSize: `${2.5 * bigScreenPayload.headerFontSize}rem` }}>
                                        {bigScreenPayload.title}
                                    </div>
                                }

                                <div className='qr-wrapper' style={{ width: `${180 * bigScreenPayload.headerRightImageSize}px` }}>
                                    {bigScreenPayload.headerRightImageUrl && <img alt="qr-code" src={bigScreenPayload.headerRightImageUrl} />}
                                </div>
                            </section>
                        }
                        <section className='lots'>
                            {bigScreenPayload.displayMode === BigScreenDisplayMode.BOTH &&
                            <BigScreenModeSwitcher bigScreenPayload={bigScreenPayload} />
                            }
                            {bigScreenPayload.displayMode === BigScreenDisplayMode.HORIZONTAL_SCROLL &&
                                <BigScreenCarouselHorizontal bigScreenPayload={bigScreenPayload} />
                            }
                            {bigScreenPayload.displayMode === BigScreenDisplayMode.VERTICAL_SCROLL &&
                                <BigScreenCarouselVertical bigScreenPayload={bigScreenPayload} />
                            }
                        </section>
                    </div>
                </div>
            }

            <BidNotificationDialog
                isDialogOpen={isBidNotificationDialogOpen}
                lot={currentLatestBid}
                bigScreenPayload={bigScreenPayload}
            />

            <AdHocDialog
                isShowAdHocPopup={bigScreenPayload.isShowAdHocPopup}
                adHocPopupWidthPercentage={bigScreenPayload.adHocPopupWidthPercentage}
                adHocPopupTitle={bigScreenPayload.adHocPopupTitle}
                adHocPopupImageUrl={bigScreenPayload.adHocPopupImageUrl}
                adHocPopupImageSize={bigScreenPayload.adHocPopupImageSize}
                adHocPopupisShowCountdown={bigScreenPayload.adHocPopupisShowCountdown}
                adHocPopupBody={bigScreenPayload.adHocPopupBody}
                countdownStartDate={bigScreenPayload.countdownStartDate}
                countdownEndDate={bigScreenPayload.countdownEndDate}
                campaignNotYetOpenTitle={bigScreenPayload.campaignNotYetOpenTitle}
                countdownClosedMessage={bigScreenPayload.countdownClosedMessage}
                campaignLiveTitle={bigScreenPayload.campaignLiveTitle}
                closeAction={() => { }}
            />
        </>
    )
}

export default BigScreen